export default {"src":"/_next/static/image/public/images/ic_umbrella.f8cbc19b9882297698b0d5b86126afb3.svg","height":51,"width":46};